import { Injectable } from '@angular/core';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';

import { saleMenuItemIds } from './navigation';
import { ITicketSseEmitter } from './services/sale-sse.service';

@Injectable()
export class SaleNavigationHelper {
  constructor(private _fuseNavigationService: FuseNavigationService) {}

  public updateBadge(ticketSseEmitter: ITicketSseEmitter): void {
    this._fuseNavigationService.updateNavigationItem(saleMenuItemIds.saleReconciledId, {
      badge: {
        title: ticketSseEmitter?.toBeReconciled,
      },
    });

    this._fuseNavigationService.updateNavigationItem(saleMenuItemIds.txNotFoundId, {
      badge: {
        title: ticketSseEmitter?.txNotFound,
      },
    });

    this._fuseNavigationService.updateNavigationItem(saleMenuItemIds.orderNotFoundId, {
      badge: {
        title: ticketSseEmitter?.orderNotFound,
      },
    });
  }
}
